import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Footer } from '../components/Footer';
import { ScrollToTop } from '../components/ScrollToTop';
export function ShoppingMarketsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const shoppingTypes = [{
    title: 'Modern Malls',
    description: 'Westgate, Sarit Centre, and The Hub offer international brands, cinemas, and food courts in air-conditioned comfort.',
    examples: ['Westgate Shopping Mall', 'Sarit Centre', 'The Hub Karen']
  }, {
    title: 'Craft Markets',
    description: 'Maasai Market and City Market showcase authentic Kenyan crafts, beadwork, textiles, and handmade souvenirs.',
    examples: ['Maasai Market', 'City Market', 'Kazuri Beads']
  }, {
    title: 'Artisan Boutiques',
    description: 'Karen and Westlands host boutique shops featuring local designers, fair-trade goods, and unique African fashion.',
    examples: ['Karen Blixen Coffee Garden', 'Village Market', 'Yaya Centre']
  }, {
    title: 'Street Markets',
    description: 'Gikomba and Toi Markets offer bargain prices on everything from clothes to electronics in authentic local settings.',
    examples: ['Gikomba Market', 'Toi Market', 'Ngara Market']
  }];
  return <div className="min-h-screen bg-white" data-id="element-1403">
      {/* Hero */}
      <div className="border-b border-gray-200" data-id="element-1404">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-32" data-id="element-1405">
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6
        }} className="max-w-3xl" data-id="element-1406">
            <h1 className="text-5xl md:text-7xl font-semibold text-charcoal mb-6 leading-tight" data-id="element-1407">
              Shopping & Markets
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 leading-relaxed" data-id="element-1408">
              From air-conditioned malls to bustling street markets, Nairobi
              offers shopping experiences for every taste and budget.
            </p>
          </motion.div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16" data-id="element-1409">
        {/* Introduction */}
        <section className="mb-20" data-id="element-1410">
          <div className="max-w-3xl" data-id="element-1411">
            <p className="text-gray-700 text-lg leading-relaxed mb-6" data-id="element-1412">
              Shopping in Nairobi is an adventure in contrasts. Modern shopping
              malls with international brands stand alongside traditional
              markets where bargaining is an art form. You can find everything
              from designer fashion to handcrafted Maasai jewelry, from the
              latest electronics to vintage treasures.
            </p>
            <p className="text-gray-700 leading-relaxed" data-id="element-1413">
              The Maasai Market, rotating through different locations weekly, is
              a must-visit for authentic souvenirs. Gikomba Market, one of East
              Africa's largest, offers incredible bargains for those willing to
              navigate its maze-like alleys.
            </p>
          </div>
        </section>

        {/* Shopping Types */}
        <section data-id="element-1414">
          <h2 className="text-2xl font-semibold text-charcoal mb-8" data-id="element-1415">
            Shopping Experiences
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-1416">
            {shoppingTypes.map((type, index) => <motion.div key={type.title} className="border border-gray-200 p-8" initial={{
            y: 20,
            opacity: 0
          }} whileInView={{
            y: 0,
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} data-id="element-1417">
                <h3 className="text-xl font-semibold text-charcoal mb-3" data-id="element-1418">
                  {type.title}
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1419">
                  {type.description}
                </p>
                <div className="space-y-1" data-id="element-1420">
                  {type.examples.map(example => <p key={example} className="text-sm text-gray-600" data-id="element-1421">
                      • {example}
                    </p>)}
                </div>
              </motion.div>)}
          </div>
        </section>
      </div>

      <ScrollToTop data-id="element-1422" />
      <Footer data-id="element-1423" />
    </div>;
}